/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box } from '@tishman/components';
import React from 'react';

import { CardDetail, CardDetailProps } from '../common/CardDetail';

export type MobileTicketCardProps = Pick<
  CardDetailProps,
  'ticket' | 'category'
>;

export function MobileTicketCard({
  category,
  ticket,
}: MobileTicketCardProps): React.JSX.Element {
  return (
    <Box
      sx={{
        mt: '36px',
      }}
    >
      <CardDetail
        buttonPosition="aboveDescription"
        category={category}
        ticket={ticket}
      />
    </Box>
  );
}
